import React, { Component } from 'react'
import { PaginateResponse } from '../services/api.service'
import ResultLimiter from './ResultLimiter'
import { TableHorizontalProps } from './TableHorizontal'
import SearchPicker from './SearchPicker'
import Paginator from './Paginator'
import CardWrapper from './CardWrapper'
import ImagePopup from './Popup/image_popup'
import RadioGroup, { RadioGroupItem } from '../components/RadioGroup'
import { i18n } from "../i18n/i18n";

export interface DataTableData<Data = {}>
  extends
    Pick<TableHorizontalProps<Data>, 'data'>,
    Omit<PaginateResponse<Data>, 'data'> {}

interface DataTableProps extends DataTableData, TableHorizontalProps {
  limit: string
  search: string
  selectedIds?: number[]
  onLimtChange: (limit: string) => void
  onSearch: (term: string) => void
  onPaginate: (page: number) => void
  onSelect?: (ids: number[]) => void

  // Adding radios
  radioOptions?: RadioGroupItem[]
  useRadios?: boolean
  defaultRadioOption?: string
  radioChange?: (selectedOption: string) => void
  limitActions?: boolean
}

interface DataTableState {
  term: string
  isPopUpOpen: boolean
  selectedImage: string

  selectedOption: string
}

export default class Gallery
  extends Component<DataTableProps, DataTableState> {
  constructor (props: DataTableProps) {
    super(props)
    this.state = {
      term: '',
      isPopUpOpen: false,
      selectedImage: '',
      selectedOption: this.props.defaultRadioOption ?? ""
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePopupClose = this.handlePopupClose.bind(this)
    this.handleImageClick = this.handleImageClick.bind(this)
    this.handleRadioChange = this.handleRadioChange.bind(this)
  }

  get status () {
    const { from, to, total } = this.props
    if (!from || !to) return null
    return `Showing ${from} to ${to} of ${total} results`
  }

  handlePopupClose(){
    this.setState({ isPopUpOpen: false, selectedImage: '' })
  }

  handleImageClick(clickedImage: string){
    this.setState({ isPopUpOpen: true, selectedImage: clickedImage })
  }

  handleSearchChange (name: string, value: string) {
    this.setState({ term: value })
  }

  handleSearch (name: string, term: string) {
    this.props.onSearch(term)
  }

  replaceStateTermWithProps () {
    this.setState({ term: this.props.search })
  }

  componentDidUpdate (props: DataTableProps) {
    if (this.props.search !== props.search) this.replaceStateTermWithProps()
  }

  componentDidMount () {
    this.replaceStateTermWithProps()
  }

  handleRadioChange (name: string) {
    this.setState({ selectedOption: name })
    if(this.props.radioChange){
      this.props.radioChange(name)
    }
  }

  render () {
    return (
      <div className="block">
        <div className="flex flex-col md:flex-row md:justify-between">
          <ResultLimiter value={this.props.limit} onChange={this.props.onLimtChange} />
          {this.props.useRadios && (
            <RadioGroup
            label={i18n('Search by type')}
            radios={this.props.radioOptions ?? []}
            checked={this.state.selectedOption}
            onChange={this.handleRadioChange} />  
          )}
          {!this.props.useRadios && (
            <SearchPicker
            name="term"
            value={this.state.term}
            onChange={this.handleSearchChange}
            onSearch={this.handleSearch} />
          )}
        </div>
        <CardWrapper
          limitActions={this.props.limitActions}
          onImageClick={this.handleImageClick}
          headers={this.props.headers}
          data={this.props.data}
          onActionClick={this.props.onActionClick}
          onEditableChange={this.props.onEditableChange}
          onSelect={this.props.onSelect}
          selectedIds={this.props.selectedIds} />
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-end">
          <p className="text-secondary text-xs mb-1">
            {this.status}
          </p>
          <Paginator
            active={this.props.currentPage}
            total={this.props.lastPage}
            onPaginate={this.props.onPaginate} />
        </div>
        <ImagePopup isOpen={this.state.isPopUpOpen} imageLink={this.state.selectedImage} handleCloseClick={this.handlePopupClose} />
      </div>
    )
  }
}
